export default {
  methods: {
    capitalize(s) {
      return s.replace(/^\w/, c => c.toUpperCase());
    },

    chunkArray(arr, size) {
      const k = Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => {
        return arr.slice(i * size, i * size + size);
      });
      return k;
    },

    clamp(val, min, max) {
      return Math.min(Math.max(val, min), max);
    },

    loadImage(path) {
      new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve({ path, status: "ok" });
        img.onerror = () => resolve({ path, status: "error" });
        img.src = path;
      });
    },

    map(value, istart, istop, ostart, ostop) {
      return ostart + (ostop - ostart) * ((value - istart) / (istop - istart));
    },

    slugify(str) {
      const first = str.replace(/['*+~, .()"!:@]/g, "-").toLowerCase();
      return first.replace(/^-+|-+(?=-|$)/g, "");
    }
  }
};
